export default "__VITE_ASSET__2A6zik4C__"